import { isEqual } from "lodash";
import { FC, Fragment, useMemo } from "react";
import { ExtraStateContext } from "..";
import InformationList, { LeftRightContent } from "../../../../components/InformationList";
import { useProcess } from "../../../../process-context";
import { FileAttachmentCard } from "../../../../upload";
import LongTermContent from "./long-term/content";
import ShortTermContent from "./short-term/content";

const FormContent: FC = () => {
  const { Request, isLongTerm, isProvide, isEvict } = useProcess<ExtraStateContext>();

  const smColData = useMemo(() => {
    return [
      {
        content: (
          <LeftRightContent
            left="Hoạt động:"
            right={<strong>{isLongTerm ? "Dài hạn" : "Ngắn hạn"}</strong>}
            smColumn={false}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Loại giấy phép:"
            right={
              <strong>
                {isLongTerm
                  ? isProvide
                    ? "Cấp mới"
                    : isEvict
                    ? "Gia hạn"
                    : "Cấp lại"
                  : isProvide
                  ? "Cấp thẻ"
                  : "Cấp lại thẻ"}
              </strong>
            }
            smColumn={false}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Người yêu cầu:"
            right={<strong>{Request.createdBy.user.displayName}</strong>}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="SĐT Người yêu cầu:"
            right={<strong>{Request.fields.ePhoneNumber}</strong>}
            smColumn={false}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Cơ quan/Đơn vị:"
            right={<strong>{Request.fields.eDepartment}</strong>}
          />
        ),
      },
      {
        hidden: {
          sm: isEqual(Request.fields.eUnit, Request.fields.eDepartment),
        },
        content: (
          <LeftRightContent
            left="Đơn vị:"
            right={<strong>{Request.fields.eUnit}</strong>}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Căn cứ theo nhu cầu:"
            right={<strong>{Request.fields.eBaseId}</strong>}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Văn bản đính kèm:"
            right={
              <div className="d-flex align-items-center">
                <FileAttachmentCard
                  listFile={
                    Request.fields.eDocumentAttach ? JSON.parse(Request.fields.eDocumentAttach) : []
                  }
                />
              </div>
            }
          />
        ),
      },
      {
        content: (
          <LeftRightContent left="Mục đích:" right={<strong>{Request.fields.ePurpose}</strong>} />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Đề Nghị Có Chữ Ký Của Lãnh Đạo Đơn Vị Ngoài:"
            right={
              <div className="d-flex align-items-center">
                <FileAttachmentCard
                  listFile={
                    Request.fields.eExternalDocument
                      ? JSON.parse(Request.fields.eExternalDocument)
                      : []
                  }
                />
              </div>
            }
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Hợp Đồng Kinh Tế Giữa VIAGS Và Đối Tác: "
            right={
              <div className="d-flex align-items-center">
                <FileAttachmentCard
                  listFile={
                    Request.fields.eDocumentary ? JSON.parse(Request.fields.eDocumentary) : []
                  }
                />
              </div>
            }
          />
        ),
      },
      // {
      //   hidden: isLongTerm,
      //   content: (
      //     <LeftRightContent
      //       left="Công Văn Đề Nghị:"
      //       right={
      //         <div className="d-flex align-items-center">
      //           <FileAttachmentCard
      //             listFile={
      //               Request.fields.eRequestLetter ? JSON.parse(Request.fields.eRequestLetter) : []
      //             }
      //           />
      //         </div>
      //       }
      //     />
      //   ),
      // },
    ];
  }, [Request, isProvide, isEvict, isLongTerm]);

  return (
    <Fragment>
      <InformationList
        size="sm-col"
        data={smColData}
        renderContent={(item) => item.content}
        getItemHidden={(item) => item.hidden}
      />
      {isLongTerm ? <LongTermContent /> : <ShortTermContent />}
    </Fragment>
  );
};

export default FormContent;
